import { createSelector } from 'reselect'

import { selectProgramType } from '../../configuration'

import { selectCompletenessState } from './selectCompletenessState'

export const selectCurrentCompleteness = createSelector(
  [selectCompletenessState, selectProgramType],
  (completeness, programType) => {
    return completeness.data.find((it) => it.profile === programType)
  }
)
